import { Box, Divider, Paper, Toolbar, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { ChartsLocalizationProvider } from "@mui/x-charts/ChartsLocalizationProvider";
import { svSELocaleText } from "@mui/x-charts/locales";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ClaimApiService from "../../adapters/xhr/ClaimApiService";
import { MyButton } from "../../components/my-button/MyButton";
import { MyDatePicker } from "../../components/my-date-picker/MyDatePicker";
import MyContext from "../../contexts/MyContext";

export const TrainStatisticsPage = () => {
  const { t, i18n } = useTranslation();
  //claims
  const [automationCurrentYearClaims, setAutomationCurrentYearClaims] = useState();
  const [manualCurrentYearClaims, setManualCurrentYearClaims] = useState();
  const [foodCurrentYearClaims, setFoodCurrentYearClaims] = useState();
  const [ownCarCurrentYearClaims, setOwnCarCurrentYearClaims] = useState();
  const [otherTransportCurrentYearClaims, setOtherTransportCurrentYearClaims] = useState();
  const [extraCurrentYearClaims, setExtraCurrentYearClaims] = useState();
  const [period30CurrentYearClaims, setPeriod30CurrentYearClaims] = useState();
  const [period90CurrentYearClaims, setPeriod90CurrentYearClaims] = useState();
  const [period365CurrentYearClaims, setPeriod365CurrentYearClaims] = useState();
  const [singleCurrentYearClaims, setSingleCurrentYearClaims] = useState();
  const [resplusCurrentYearClaims, setResplusCurrentYearClaims] = useState();
  const [currentYearClaims, setCurrentYearClaims] = useState();
  const [lastYearClaims, setLastYearClaims] = useState();
  const [dailyClaims, setDailyClaims] = useState();
  // reimbursement
  const [currentYearReimbursement, setCurrentYearReimbursement] = useState();
  const [lastYearReimbursement, setLastYearReimbursement] = useState();
  const [foodCurrentYearReimbursement, setFoodCurrentYearReimbursement] = useState();
  const [ownCarCurrentYearReimbursement, setOwnCarCurrentYearReimbursement] = useState();
  const [otherTransportCurrentYearReimbursement, setOtherTransportCurrentYearReimbursement] = useState();
  const [extraCurrentYearReimbursement, setExtraCurrentYearReimbursement] = useState();
  const [period30CurrentYearReimbursement, setPeriod30CurrentYearReimbursement] = useState();
  const [period90CurrentYearReimbursement, setPeriod90CurrentYearReimbursement] = useState();
  const [period365CurrentYearReimbursement, setPeriod365CurrentYearReimbursement] = useState();
  const [singleCurrentYearReimbursement, setSingleCurrentYearReimbursement] = useState();
  const [resplusCurrentYearReimbursement, setResplusCurrentYearReimbursement] = useState();
  // top
  const [mostCommonTrainNumbers, setMostCommonTrainNumbers] = useState();
  const [trainNumbersWithMostReimbursement, setTrainNumbersWithMostReimbursement] = useState();
  const [mostCommonRoutes, setMostCommonRoutes] = useState();
  const [routesWithMostReimbursement, setRoutesWithMostReimbursement] = useState();

  const [date, setDate] = useState(new Date().toString());
  const [year, setYear] = useState();
  const [month, setMonth] = useState();
  const [day, setDay] = useState();

  const months = ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"];

  const days = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];

  const myContext = useContext(MyContext);

  const fetchMonthlyClaims = useCallback(async () => {
    const promises = [];

    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), automated: true }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), automated: false }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), receiptType: "Food" }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), receiptType: "OwnCar" }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), receiptType: "Other" }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), receiptType: "Extra" }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear() }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear() - 1 }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), ticketType: "Period30" }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), ticketType: "Period90" }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), ticketType: "Period365" }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), ticketType: "Single" }));
    promises.push(ClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), ticketType: "Resplus" }));

    const [automationCurrentYearClaimsResponse, manualCurrentYearClaimsResponse, foodCurrentYearClaimsResponse, ownCarCurrentYearClaimsResponse, otherTransportCurrentYearClaimsResponse, extraCurrentYearClaimsResponse, currentYearClaimsResponse, lastYearClaimsResponse, period30CurrentYearResponse, period90CurrentYearResponse, period365CurrentYearResponse, singleCurrentYearResponse, resplusCurrentYearResponse] = await Promise.all(promises);

    if (automationCurrentYearClaimsResponse?.isSuccess && manualCurrentYearClaimsResponse?.isSuccess && foodCurrentYearClaimsResponse?.isSuccess && ownCarCurrentYearClaimsResponse?.isSuccess && otherTransportCurrentYearClaimsResponse?.isSuccess && extraCurrentYearClaimsResponse?.isSuccess && currentYearClaimsResponse?.isSuccess && lastYearClaimsResponse?.isSuccess && period30CurrentYearResponse?.isSuccess && period90CurrentYearResponse?.isSuccess && period365CurrentYearResponse?.isSuccess && singleCurrentYearResponse?.isSuccess && resplusCurrentYearResponse?.isSuccess) {
      setAutomationCurrentYearClaims(automationCurrentYearClaimsResponse.data);
      setManualCurrentYearClaims(manualCurrentYearClaimsResponse.data);
      setFoodCurrentYearClaims(foodCurrentYearClaimsResponse.data);
      setOwnCarCurrentYearClaims(ownCarCurrentYearClaimsResponse.data);
      setOtherTransportCurrentYearClaims(otherTransportCurrentYearClaimsResponse.data);
      setExtraCurrentYearClaims(extraCurrentYearClaimsResponse.data);
      setCurrentYearClaims(currentYearClaimsResponse.data);
      setLastYearClaims(lastYearClaimsResponse.data);
      setPeriod30CurrentYearClaims(period30CurrentYearResponse.data);
      setPeriod90CurrentYearClaims(period90CurrentYearResponse.data);
      setPeriod365CurrentYearClaims(period365CurrentYearResponse.data);
      setSingleCurrentYearClaims(singleCurrentYearResponse.data);
      setResplusCurrentYearClaims(resplusCurrentYearResponse.data);
    }
  }, [date]);

  const fetchMonthlyReimbursement = useCallback(async () => {
    const promises = [];

    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), receiptType: "Food" }));
    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), receiptType: "OwnCar" }));
    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), receiptType: "Other" }));
    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), receiptType: "Extra" }));
    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear() }));
    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear() - 1 }));
    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), ticketType: "Period30" }));
    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), ticketType: "Period90" }));
    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), ticketType: "Period365" }));
    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), ticketType: "Single" }));
    promises.push(ClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), ticketType: "Resplus" }));

    const [foodCurrentYearReimbursementResponse, ownCarCurrentYearReimbursementResponse, otherTransportCurrentYearReimbursementResponse, extraCurrentYearReimbursementResponse, currentYearReimbursementResponse, lastYearReimbursementResponse, period30CurrentYearReimbursementResponse, period90CurrentYearReimbursementResponse, period365CurrentYearReimbursementResponse, singleCurrentYearReimbursementResponse, resplusCurrentYearReimbursementResponse] = await Promise.all(promises);

    if (foodCurrentYearReimbursementResponse?.isSuccess && ownCarCurrentYearReimbursementResponse?.isSuccess && otherTransportCurrentYearReimbursementResponse?.isSuccess && extraCurrentYearReimbursementResponse?.isSuccess && currentYearReimbursementResponse?.isSuccess && lastYearReimbursementResponse?.isSuccess && period30CurrentYearReimbursementResponse?.isSuccess && period90CurrentYearReimbursementResponse?.isSuccess && period365CurrentYearReimbursementResponse?.isSuccess && singleCurrentYearReimbursementResponse?.isSuccess && resplusCurrentYearReimbursementResponse?.isSuccess) {
      setFoodCurrentYearReimbursement(foodCurrentYearReimbursementResponse.data);
      setOwnCarCurrentYearReimbursement(ownCarCurrentYearReimbursementResponse.data);
      setOtherTransportCurrentYearReimbursement(otherTransportCurrentYearReimbursementResponse.data);
      setExtraCurrentYearReimbursement(extraCurrentYearReimbursementResponse.data);
      setCurrentYearReimbursement(currentYearReimbursementResponse.data);
      setLastYearReimbursement(lastYearReimbursementResponse.data);
      setPeriod30CurrentYearReimbursement(period30CurrentYearReimbursementResponse.data);
      setPeriod90CurrentYearReimbursement(period90CurrentYearReimbursementResponse.data);
      setPeriod365CurrentYearReimbursement(period365CurrentYearReimbursementResponse.data);
      setSingleCurrentYearReimbursement(singleCurrentYearReimbursementResponse.data);
      setResplusCurrentYearReimbursement(resplusCurrentYearReimbursementResponse.data);
    }
  }, [date]);

  const fetchDailyClaims = useCallback(async () => {
    const promises = [];

    promises.push(ClaimApiService.getDailyClaims({ year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1 }));

    const [dailyClaimsResponse] = await Promise.all(promises);

    if (dailyClaimsResponse?.isSuccess) {
      setDailyClaims(dailyClaimsResponse.data);
    }
  }, [date]);

  const fetchMostCommonTrainNumbers = useCallback(async () => {
    const promises = [];

    promises.push(ClaimApiService.getMostCommonTrainNumbers({ year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate() }));

    const [mostCommonTrainNumbersResponse] = await Promise.all(promises);

    if (mostCommonTrainNumbersResponse?.isSuccess) {
      setMostCommonTrainNumbers(mostCommonTrainNumbersResponse.data);
    }
  }, [date]);

  const fetchTrainNumbersWithMostReimbursement = useCallback(async () => {
    const promises = [];

    promises.push(ClaimApiService.getMostCommonTrainNumbers({ mostReimbursement: true, year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate() }));

    const [response] = await Promise.all(promises);

    if (response?.isSuccess) {
      setTrainNumbersWithMostReimbursement(response.data);
    }
  }, [date]);

  const fetchMostCommonRoutes = useCallback(async () => {
    const promises = [];

    promises.push(ClaimApiService.getMostCommonRoutes({ year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate() }));

    const [mostCommonRoutesResponse] = await Promise.all(promises);

    if (mostCommonRoutesResponse?.isSuccess) {
      setMostCommonRoutes(mostCommonRoutesResponse.data);
    }
  }, [date]);

  const fetchRoutesWithMostReimbursement = useCallback(async () => {
    const promises = [];

    promises.push(ClaimApiService.getMostCommonRoutes({ mostReimbursement: true, year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate() }));

    const [response] = await Promise.all(promises);

    if (response?.isSuccess) {
      setRoutesWithMostReimbursement(response.data);
    }
  }, [date]);

  useEffect(() => {
    fetchRoutesWithMostReimbursement();
  }, [date, fetchRoutesWithMostReimbursement]);

  useEffect(() => {
    fetchMostCommonRoutes();
  }, [date, fetchMostCommonRoutes]);

  useEffect(() => {
    fetchTrainNumbersWithMostReimbursement();
  }, [date, fetchTrainNumbersWithMostReimbursement]);

  useEffect(() => {
    fetchMostCommonTrainNumbers();
  }, [date, fetchMostCommonTrainNumbers]);

  useEffect(() => {
    fetchMonthlyClaims();
  }, [date, fetchMonthlyClaims]);

  useEffect(() => {
    fetchMonthlyReimbursement();
  }, [date, fetchMonthlyReimbursement]);

  useEffect(() => {
    fetchDailyClaims();
  }, [date, fetchDailyClaims]);

  const exportExcel = async () => {
    var response = await ClaimApiService.getStatisticsInExcel({ year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate() });
    // Create a URL for the Blob and trigger download
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Charts.xlsx"); // Set the desired file name for download
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url); // Clean up the object URL
  };

  const currentMonth = () => {
    const now = new Date(date);
    return `${now.getFullYear()} ${months[now.getMonth()]}`;
  };

  const currentDay = () => {
    const now = new Date(date);
    return `${now.getFullYear()} ${months[now.getMonth()]} ${now.getDate()}`;
  };

  return (
    <ChartsLocalizationProvider localeText={svSELocaleText}>
      <Paper>
        <Box sx={{ display: "flex" }}>
          <MyDatePicker size="small" onAccept={(date) => setDate(date.toString())} value={date} label={t("date")} style={{ width: "12rem", margin: "1rem 0 1rem 1rem" }} />
          <MyButton text={t("export_to_excel")} color="primary" onClick={async (e) => await exportExcel()} style={{ width: "15rem", margin: "1rem 5rem 1rem 1rem" }} />
        </Box>
        <Divider />
        <Toolbar>
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("number_of_claims_per_month")}
          </Typography>
        </Toolbar>
        {currentYearClaims && lastYearClaims && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ current: currentYearClaims[index], last: lastYearClaims[index], month }))}
            series={[
              { dataKey: "current", label: new Date(date).getFullYear().toString(), valueFormatter: (value) => `${value}` },
              { dataKey: "last", label: (new Date(date).getFullYear() - 1).toString(), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month" }]}
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("number_of_claims_per_day")}
          </Typography>
        </Toolbar>
        {dailyClaims && (
          <BarChart
            xAxis={[{ data: days, label: currentMonth() }]}
            //
            series={[{ data: dailyClaims, valueFormatter: (value) => `${value}` }]}
            height={300}
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("number_of_claims_per_cost")}
          </Typography>
        </Toolbar>
        {foodCurrentYearClaims && ownCarCurrentYearClaims && otherTransportCurrentYearClaims && extraCurrentYearClaims && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ food: foodCurrentYearClaims[index], ownCar: ownCarCurrentYearClaims[index], otherTransport: otherTransportCurrentYearClaims[index], extra: extraCurrentYearClaims[index], month }))}
            series={[
              { dataKey: "food", label: t("food"), valueFormatter: (value) => `${value}` },
              { dataKey: "ownCar", label: t("own_car"), valueFormatter: (value) => `${value}` },
              { dataKey: "otherTransport", label: t("other_transport"), valueFormatter: (value) => `${value}` },
              { dataKey: "extra", label: t("accommodation"), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("number_of_claims_per_ticket_type")}
          </Typography>
        </Toolbar>
        {period30CurrentYearClaims && period90CurrentYearClaims && period365CurrentYearClaims && singleCurrentYearClaims && resplusCurrentYearClaims && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ period30: period30CurrentYearClaims[index], period90: period90CurrentYearClaims[index], period365: period365CurrentYearClaims[index], single: singleCurrentYearClaims[index], resplus: resplusCurrentYearClaims[index], month }))}
            series={[
              { dataKey: "period30", label: t("Period30"), valueFormatter: (value) => `${value}` },
              { dataKey: "period90", label: t("Period90"), valueFormatter: (value) => `${value}` },
              { dataKey: "period365", label: t("Period365"), valueFormatter: (value) => `${value}` },
              { dataKey: "single", label: t("single"), valueFormatter: (value) => `${value}` },
              { dataKey: "resplus", label: t("Ej kategoriserade"), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("number_of_claims_that_has_gone_for_automation_vs_manual_handling")}
          </Typography>
        </Toolbar>
        {automationCurrentYearClaims && manualCurrentYearClaims && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ automation: automationCurrentYearClaims[index], manual: manualCurrentYearClaims[index], month }))}
            series={[
              { dataKey: "automation", label: t("automation"), valueFormatter: (value) => `${value}` },
              { dataKey: "manual", label: t("manual"), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("paid_reimbursement_per_month")}
          </Typography>
        </Toolbar>
        {currentYearReimbursement && lastYearReimbursement && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ current: currentYearReimbursement[index], last: lastYearReimbursement[index], month }))}
            series={[
              { dataKey: "current", label: new Date().getFullYear().toString(), valueFormatter: (value) => `${value}` },
              { dataKey: "last", label: (new Date().getFullYear() - 1).toString(), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
            // barLabel="value"
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("paid_reimbursement_per_cost")}
          </Typography>
        </Toolbar>
        {foodCurrentYearReimbursement && ownCarCurrentYearReimbursement && otherTransportCurrentYearReimbursement && extraCurrentYearReimbursement && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ food: foodCurrentYearReimbursement[index], ownCar: ownCarCurrentYearReimbursement[index], otherTransport: otherTransportCurrentYearReimbursement[index], extra: extraCurrentYearReimbursement[index], month }))}
            series={[
              { dataKey: "food", label: t("food"), valueFormatter: (value) => `${value}` },
              { dataKey: "ownCar", label: t("own_car"), valueFormatter: (value) => `${value}` },
              { dataKey: "otherTransport", label: t("other_transport"), valueFormatter: (value) => `${value}` },
              { dataKey: "extra", label: t("accommodation"), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
            // barLabel="value"
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("paid_reimbursement_per_ticket_type")}
          </Typography>
        </Toolbar>
        {period30CurrentYearReimbursement && period90CurrentYearReimbursement && period365CurrentYearReimbursement && singleCurrentYearReimbursement && resplusCurrentYearReimbursement && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ period30: period30CurrentYearReimbursement[index], period90: period90CurrentYearReimbursement[index], period365: period365CurrentYearReimbursement[index], single: singleCurrentYearReimbursement[index], resplus: resplusCurrentYearReimbursement[index], month }))}
            series={[
              { dataKey: "period30", label: t("Period30"), valueFormatter: (value) => `${value}` },
              { dataKey: "period90", label: t("Period90"), valueFormatter: (value) => `${value}` },
              { dataKey: "period365", label: t("Period365"), valueFormatter: (value) => `${value}` },
              { dataKey: "single", label: t("single"), valueFormatter: (value) => `${value}` },
              { dataKey: "resplus", label: t("Ej kategoriserade"), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
            // barLabel="value"
          />
        )}
        {/* common routes/train numbers */}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("top_20_most_common_train_numbers")}
          </Typography>
        </Toolbar>
        {mostCommonTrainNumbers && <BarChart xAxis={[{ label: currentDay(), tickMinStep: 1, data: mostCommonTrainNumbers.map((item) => item.trainNumber), categoryGapRatio: 0.9 }]} series={[{ data: mostCommonTrainNumbers.map((item) => item.count), valueFormatter: (value) => `${value}` }]} height={300} />}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("top_20_train_numbers_with_most_reimbursement")}
          </Typography>
        </Toolbar>
        {trainNumbersWithMostReimbursement && <BarChart xAxis={[{ label: currentDay(), data: trainNumbersWithMostReimbursement.map((item) => item.trainNumber), categoryGapRatio: 0.9 }]} series={[{ data: trainNumbersWithMostReimbursement.map((item) => item.reimbursementSEK), valueFormatter: (value) => `${value}` }]} height={300} />}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("top_20_most_common_routes")}
          </Typography>
        </Toolbar>
        {mostCommonRoutes && <BarChart layout="horizontal" xAxis={[{ label: currentDay(), tickMinStep: 1 }]} yAxis={[{ width: 200, data: mostCommonRoutes.map((item) => `${item.departureStation} - ${item.arrivalStation}`), categoryGapRatio: 0.9 }]} series={[{ data: mostCommonRoutes.map((item) => item.count), valueFormatter: (value) => `${value}` }]} height={350} />}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("top_20_routes_with_most_reimbursement")}
          </Typography>
        </Toolbar>
        {routesWithMostReimbursement && <BarChart layout="horizontal" xAxis={[{ label: currentDay() }]} yAxis={[{ width: 200, data: routesWithMostReimbursement.map((item) => `${item.departureStation} - ${item.arrivalStation}`), categoryGapRatio: 0.9 }]} series={[{ data: routesWithMostReimbursement.map((item) => item.reimbursementSEK), valueFormatter: (value) => `${value}` }]} height={350} />}
        <br />
        <br />
        <br />
        <br />
      </Paper>
    </ChartsLocalizationProvider>
  );
};
